module.exports = "/img/toyota.3f4f8bbb.png";